"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.artifactType = 'cashResponseTape';
exports.NodeConfigSchema = v4_1.z
    .object({
    cashBalancesFeedContextArtifactSlug: v4_1.z
        .string()
        .describe('Slug for cash balances feed context artifact'),
    receivableResponseTapeArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Optional slug for receivable response tape artifact'),
})
    .describe('DB node configuration');
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    loanProductSlug: v4_1.z.null(),
    creditFacilitySlug: v4_1.z.string(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map